import { createMutationAtom } from 'atoms/create-resource-atom';
import { DcaWorkspaceResponse } from 'types/dca-workspaces';

const createDcaWorkspaceAtom = createMutationAtom<
  DcaWorkspaceResponse,
  'createDcaWorkspace'
>();

export { createDcaWorkspaceAtom };
